var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 11.3367C28.405 11.3209 28.2941 11.3209 28.1991 11.3367C26.0141 11.2575 24.2725 9.46836 24.2725 7.25169C24.2725 4.98752 26.0933 3.16669 28.3575 3.16669C30.6216 3.16669 32.4425 5.00336 32.4425 7.25169C32.4266 9.46836 30.685 11.2575 28.5 11.3367Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.869 22.8634C29.0382 23.2275 31.429 22.8475 33.1074 21.7234C35.3399 20.235 35.3399 17.7967 33.1074 16.3084C31.4132 15.1842 28.9907 14.8042 26.8215 15.1842",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45251 11.3367C9.54751 11.3209 9.65834 11.3209 9.75334 11.3367C11.9383 11.2575 13.68 9.46836 13.68 7.25169C13.68 4.98752 11.8592 3.16669 9.59501 3.16669C7.33085 3.16669 5.51001 5.00336 5.51001 7.25169C5.52584 9.46836 7.26751 11.2575 9.45251 11.3367Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0834 22.8634C8.91419 23.2275 6.52336 22.8475 4.84503 21.7234C2.61253 20.235 2.61253 17.7967 4.84503 16.3084C6.5392 15.1842 8.96169 14.8042 11.1309 15.1842",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23.1641C18.905 23.1483 18.7941 23.1483 18.6991 23.1641C16.5141 23.085 14.7725 21.2958 14.7725 19.0791C14.7725 16.815 16.5933 14.9941 18.8575 14.9941C21.1216 14.9941 22.9425 16.8308 22.9425 19.0791C22.9266 21.2958 21.185 23.1008 19 23.1641Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3924 28.1516C12.1599 29.64 12.1599 32.0783 14.3924 33.5666C16.9257 35.2608 21.0741 35.2608 23.6074 33.5666C25.8399 32.0783 25.8399 29.64 23.6074 28.1516C21.0899 26.4733 16.9257 26.4733 14.3924 28.1516Z",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.9351de3ec29f5af97e4e36439374f117.svg";
export { ForwardRef as ReactComponent };